import { FieldsData } from '@kenjiuno/msgreader';
import axios from 'axios';
import { EmailFields, getMsgFileMetaDataWithAttachments } from 'components/MsgReader';
import produce from 'immer';
import { convertToBase64 } from 'lib/PublicFunctions';
import React, { useEffect, useState } from 'react';
import Dropzone from 'react-dropzone';
import AsyncSelect from 'react-select/async';
import { customStyles, DocumentOptions, UploadButton } from './styles';
import { FileUpload, OrderDetails, PropertyDropdownOption, UploadSdaViewModel } from './types';
import { base64ToUrl } from 'components/orders/order-information/PreviewMergedDocsStyled';
import { XIcon } from 'components/ui/icons';
import styled from '@emotion/styled';
import PropertiesDropdown from 'lib/PropertiesDropdown';
import Button from 'components/ui/Button';
import ConfirmActionModal from 'components/ui/ConfirmActionModal';
import { FrontMessage } from '../UploadContin/types';
import { Loader } from 'semantic-ui-react';

const DocumentUploaded = styled.div<{ noMargin?: boolean; minWidth?: string; noWidth?: boolean }>`
  background-color: #f7f7f9;
  border-radius: 5px;
  height: 40px;
  padding: 10px 16px;
  display: inline-block;
  min-width: ${props => props.minWidth};
  width: ${props => (props.noWidth ? 'auto' : '376px')};
  margin-top: 6px;
  margin-left: ${props => (props.noMargin ? 0 : '200px')};
  position: relative;
`;

export default function UploadSda() {
  const [orderDetails, setOrderDetails] = useState<OrderDetails>({
    id: null,
    titleNumber: '',
    clientId: null,
    integrationType: null,
  });
  const [properties, setProperties] = useState<PropertyDropdownOption[]>([]);
  const [allSearchesOfOrder, setAllSearchesOfOrder] = useState([]);
  const [files, setFiles] = useState<FileUpload[]>([]);
  const [attachments, setAttachments] = useState<FileUpload[]>([]);
  const [msgData, setMsgData] = useState<EmailFields>();
  const [isLoading, setIsLoading] = useState(false);
  const [savePopup, setSavePopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showRequestedModal, setShowRequestedModal] = useState(false);
  const [frontMessageId, setFrontMessageId] = useState('');
  const [frontMessageLoading, setFrontMessageLoading] = useState(false);

  const requestedMunicipalSearchSelected = properties?.find(
    p => p.municipalityId != 3531 && p.municipalSearches.find(m => m.searchStatusType == 'Requested')
  ); // excludes Carmel

  useEffect(() => {
    if (requestedMunicipalSearchSelected) {
      setShowRequestedModal(true);
    }
  }, [requestedMunicipalSearchSelected]);

  const createModalString = () => {
    const headerString = 'The following searches are marked as Requested:\n\n';
    const bodyString = properties
      .filter(
        p => p.municipalityId != 3531 && p.municipalSearches.find(m => m.searchStatusType == 'Requested')
      )
      .map(property => {
        return `${property.label}: ${getPropertySearchesString(property)}`;
      })
      .join('\n\n');
    return headerString + bodyString;
  };

  const getPropertySearchesString = (property: PropertyDropdownOption) => {
    return property.municipalSearches
      .filter(s => s.searchStatusType == 'Requested')
      .map(search => {
        return `\n • ${search.searchType}`;
      });
  };

  const createStatusesString = () => {
    const headerText = 'Statuses:\n\n';
    const bodyText = properties
      .map(p => {
        return `${p.label}: ${getPropertyStatusString(p)}`;
      })
      .join('\n\n');
    return headerText + bodyText;
  };

  const getPropertyStatusString = (p: PropertyDropdownOption) => {
    return p.municipalSearches.length > 0
      ? p.municipalSearches.map(s => {
          return `\n • ${s.searchType}: ${s.searchStatusType}`;
        })
      : ' No municipal searches';
  };

  const onDrop = async (newFiles: any) => {
    const arr: FileUpload[] = [];
    for (let file of newFiles) {
      const base64 = (await convertToBase64(file)) as string;
      const tempFile: FileUpload = {
        file: base64,
        actualFileName: file.name,
      };
      const extension = file?.name?.substring(file?.name?.lastIndexOf('.'));

      arr.push(tempFile);
    }

    const newArray = produce(files, draft => {
      for (let file of arr) {
        draft.push(file);
      }
    });
    setFiles(newArray);
    const msgData = await getMsgFileMetaDataWithAttachments(newFiles[0], '.pdf');
    parseMsgFile(msgData.messageData);
    setAttachments(msgData.attachmentData);
    setMsgData(msgData.messageData);
  };
  const onDropSda = async (newFiles: any) => {
    const arr: FileUpload[] = [];
    for (let file of newFiles) {
      const base64 = (await convertToBase64(file)) as string;
      const tempFile: FileUpload = {
        file: base64,
        actualFileName: file.name,
      };
      const extension = file?.name?.substring(file?.name?.lastIndexOf('.'));

      arr.push(tempFile);
    }

    const newArray = produce(attachments, draft => {
      for (let file of arr) {
        draft.push(file);
      }
    });
    setAttachments(newArray);
  };

  const onRemoveFileClick = (index: any) => {
    setAttachments(attachments.filter((f: any, i: any) => i !== index));
  };

  // const changeCustomFileName = (index: number) => (newName: string) => {
  //   const newFiles = produce(attachments, draft => {
  //     const fileName = draft[index].actualFileName;
  //     const extension = fileName.substring(fileName.lastIndexOf('.'));
  //     var startExtension = newName.lastIndexOf('.');
  //     const newExtension = newName.substring(startExtension);
  //     const removedExtensionFromName = startExtension > -1 ? newName.substring(0, startExtension) : newName;
  //     draft[index].actualFileName = `${removedExtensionFromName}${
  //       startExtension === -1 || newExtension.length > 5 ? extension : newExtension
  //     }`;
  //   });
  //   setFiles(newFiles);
  // };

  const searchOrders = async (searchTerm: string, urlPart: string = 'simpleOrderSearch') => {
    const { data } = await axios.get(`/api/orders/${urlPart}?searchTerm=${searchTerm}`);
    return data.map((order: any) => ({
      ...order,
      label: `HDS${order.id} - ${order.titleNumber}`,
      value: order.id,
    }));
  };
  const onPasteFrontMessageId = async (frontMessageId: string) => {
    setFrontMessageLoading(true);
    const { data } = await axios.get<FrontMessage>(`/api/front/GetMessageInfoForFrontIdWithAttachments/${frontMessageId}`);
    setFrontMessageId(frontMessageId);
    var from = data.recipients.find(r => r.role === 'from');
    var messageData: EmailFields = {
      subject: data.subject,
      senderEmail: from?.handle || '',
      ccEmails: data.recipients.filter(r => r.role === 'cc').map(r => r.handle),
    };
    parseMsgFile(messageData);
    setMsgData(messageData);
    setAttachments(data.attachments.map(att => ({
      actualFileName: att.filename,
      file: att.base64
    })));
    setFrontMessageLoading(false);
  }

  const parseMsgFile = async (fieldsData: EmailFields) => {
    const subject = fieldsData.subject;
    const promiseArray = subject.split(' ').map(async word => {
      const orders = await searchOrders(word, 'SearchOrderByTitleNumber');
      if (orders.length === 1) {
        return {
          order: orders[0],
        };
      } else {
        return null;
      }
    });
    const orders = await Promise.all(promiseArray);
    const orderFound = orders.find(o => o);
    if (orderFound) {
      setOrderDetails(orderFound.order);
    }
  };

  const submit = async () => {
    if (attachments.length === 0) {
      setErrorMessage('Please Upload an SDA File');
      return;
    }
    if (!orderDetails.id) {
      setErrorMessage('Please Select an order');
      return;
    }
    const submitObj: UploadSdaViewModel = {
      documentTypeId: 6,
      files: attachments,
      propertyIds: properties.map(property => property.value),
      searchCategoryId: 1,
      fromSdaUpload: true,
    };

    setIsLoading(true);
    await axios.post(`/api/orders/uploadSearchDocument`, submitObj);
    setIsLoading(false);
    setSavePopup(true);

    setTimeout(() => {
      setSavePopup(false);
      setOrderDetails({ id: null, titleNumber: '', clientId: null, integrationType: null });
      setProperties([]);
      setFiles([]);
      setMsgData(null);
      setAttachments([]);
      setAllSearchesOfOrder([]);
      setErrorMessage('');
      setFrontMessageId('');
    }, 1500);
  };

  return (
    <>
      <div style={{ fontWeight: 'bold', fontSize: 24, paddingBottom: 16 }}>Upload SDA</div>
      <div style={{ marginBottom: 16 }}>
        <label style={{ display: 'block', marginBottom: 4, fontSize: 14 }}>Front Message ID</label>
        <input
          type="text"
          value={frontMessageId}
          onChange={(e) => setFrontMessageId(e.target.value)}
          onPaste={e => onPasteFrontMessageId(e.clipboardData.getData('Text'))}
          placeholder="Enter Front Message ID"
          style={{
            padding: '8px 12px',
            border: '1px solid #e5e5ea',
            borderRadius: 4,
            width: 376,
            fontSize: 14
          }}
        />
      </div>
      {frontMessageLoading && <Loader active inline />}
      <Dropzone onDrop={onDrop}>
        {({ getRootProps, getInputProps, isDragActive }) => {
          return (
            <DocumentOptions>
              <div {...getRootProps()}>
                <input {...getInputProps()} />
                <div style={{ textAlign: 'center' }}>
                  {isDragActive ? <span>drop here</span> : <span>Drag and drop Email</span>}

                  <div style={{ color: '#e5e5ea', paddingTop: 8, paddingBottom: 8 }}>Or</div>
                  {/* <UploadButton>Select File</UploadButton> */}
                </div>
              </div>
            </DocumentOptions>
          );
        }}
      </Dropzone>
      {msgData && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <div style={{ paddingTop: 16 }}>Email Currently processing:</div>
          <div>
            <span style={{ textTransform: 'uppercase', fontWeight: 'bold', marginRight: 8 }}>subject: </span>
            {msgData.subject}
          </div>
          <div>
            <span style={{ textTransform: 'uppercase', fontWeight: 'bold', marginRight: 8 }}>from:</span>
            {msgData.senderEmail}
          </div>
        </div>
      )}
      <div style={{ display: 'flex' }}>
        <div style={{ flexDirection: 'column', marginRight: 16, marginTop: 16 }}>
          <span style={{ marginBottom: 8, display: 'inline-block' }}>File Number:</span>
          <AsyncSelect
            value={
              orderDetails?.id
                ? { value: orderDetails?.id, label: `HDS${orderDetails?.id} - ${orderDetails?.titleNumber}` }
                : null
            }
            loadOptions={searchTerm => searchOrders(searchTerm)}
            styles={customStyles}
            isClearable
            placeholder="Start Typing..."
            onChange={(e: any) => {
              setOrderDetails(e);
            }}
          />
        </div>
      </div>
      {orderDetails?.id && (
        <div style={{ marginTop: 32, display: 'flex' }}>
          <PropertiesDropdown
            selectedProperties={properties}
            onChangeProperties={selected => setProperties(selected as DropdownOption[])}
            orderId={orderDetails.id}
          />
          {properties.length > 0 && (
            <div
              style={{
                marginLeft: 450,
                whiteSpace: 'pre-wrap',
                padding: 20,
                border: '2px solid lightgrey',
                borderRadius: 5,
              }}
            >
              {createStatusesString()}
            </div>
          )}
        </div>
      )}
      {attachments.length > 0 && <div style={{ paddingTop: 16 }}>SDA files to be Uploaded: </div>}
      {attachments.map((file: FileUpload, index: any) => {
        return (
          <div key={file.actualFileName} style={{ marginLeft: '-200px' }}>
            <DocumentUploaded>
              <div>
                <span>
                  <a href={base64ToUrl(file.file)} target="_none">
                    {file.actualFileName}
                  </a>
                </span>
                <div
                  onClick={() => onRemoveFileClick(index)}
                  style={{ position: 'absolute', right: 16, top: 8, cursor: 'pointer', zIndex: 5000 }}
                >
                  <XIcon />
                </div>
              </div>
            </DocumentUploaded>
          </div>
        );
      })}

      {orderDetails?.id && (
        <div>
          <div style={{ marginTop: 16 }}>
            <Dropzone onDrop={onDropSda}>
              {({ getRootProps, getInputProps, isDragActive }) => {
                return (
                  <DocumentOptions>
                    <div {...getRootProps()}>
                      <input {...getInputProps()} />
                      <div style={{ textAlign: 'center' }}>
                        {isDragActive ? <span>drop here</span> : <span>Drag and drop SDA Doc</span>}

                        <div style={{ color: '#e5e5ea', paddingTop: 8, paddingBottom: 8 }}>Or</div>
                        <UploadButton>Select SDA</UploadButton>
                      </div>
                    </div>
                  </DocumentOptions>
                );
              }}
            </Dropzone>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              marginRight: 60,
              marginTop: 30,
              position: 'relative',
            }}
          >
            {errorMessage && (
              <div style={{ color: '#ff5252', position: 'absolute', right: 0, top: -20 }}>{errorMessage}</div>
            )}
            <Button onClick={submit} loadingStatus={isLoading}>
              Submit
            </Button>
            {savePopup && (
              <div
                style={{
                  color: '#fff',
                  fontWeight: 'bold',
                  position: 'absolute',
                  bottom: 65,
                  //right: 50,
                  backgroundColor: '#333',
                  padding: 8,
                  borderRadius: 4,
                }}
              >
                SDA Uploaded!
              </div>
            )}
          </div>
        </div>
      )}
      {showRequestedModal && (
        <ConfirmActionModal
          openState={showRequestedModal}
          onClose={() => setShowRequestedModal(false)}
          header={'Continue Uploading SDA'}
          info={createModalString()}
          actionFunction={() => setShowRequestedModal(false)}
          hideSecondaryButton={true}
          buttonText="Close"
          height={450}
        />
      )}
    </>
  );
}
